import { ChangeEvent } from 'react'
import { InputPropsTypeOption } from 'src/components/atomic/atom/Input'
import { setEmail, setPinValue } from 'src/store/Reducer/page/loginPageSlice'
import { setConfirmPin, setCreatePin } from 'src/store/Reducer/page/resetPageSlice'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import {
  setDeleteDataInputValue,
  setUnlockDeviceInputValue,
} from 'src/store/Reducer/common/modalSlice'
import { setTempGPNumber } from 'src/store/Reducer/socket/homePageSlice'

export const useOnInputHook = () => {
  // const EnglishSpace = [/^[a-z]+$/, /[^a-z]/g]
  // const english = [/^[A-Za-z]+$/, /[^A-Za-z]/g]
  const number = [/^[0-9]+$/, /[^0-9]/g]
  const englishOrNumber = [/^[A-Za-z0-9@._-]+$/, /[^A-Za-z0-9@._-]/g]
  const dispatch = useAppDispatch()
  const setValidFunc = (e: ChangeEvent<HTMLInputElement>, option: InputPropsTypeOption) => {
    const value = e.target.value
    switch (option) {
      case 'unLockDevice_modal':
        switch (true) {
          case value?.length > 6:
            return dispatch(setUnlockDeviceInputValue(value.slice(0, 6)))
          default:
            return dispatch(setUnlockDeviceInputValue(value))
        }
      case 'deleteData_modal':
        switch (true) {
          case value?.length > 6:
            return dispatch(setDeleteDataInputValue(value.slice(0, 6)))
          default:
            return dispatch(setDeleteDataInputValue(value))
        }
      case 'email':
        switch (true) {
          case value?.length > 40:
            return dispatch(setEmail(value.slice(0, 40).replace(englishOrNumber[1], '')))
          case !englishOrNumber[0].test(value):
            return dispatch(setEmail(value.replace(englishOrNumber[1], '')))
          default:
            return dispatch(setEmail(value))
        }
      case 'emergency_contact':
        switch (true) {
          case value?.length > 15:
            return dispatch(setTempGPNumber(value.slice(0, 15).replace(number[1], '')))
          case !number[0].test(value):
            return dispatch(setTempGPNumber(value.replace(number[1], '')))
          default:
            return dispatch(setTempGPNumber(value))
        }
      case 'login_pin':
        switch (true) {
          case value?.length > 6:
            return dispatch(setPinValue(value.slice(0, 6).replace(number[1], '')))
          case !number[0].test(value):
            return dispatch(setPinValue(value.replace(number[1], '')))
          default:
            return dispatch(setPinValue(value))
        }
      case 'reset_create_pin':
        switch (true) {
          case value?.length > 6:
            return dispatch(setCreatePin(value.slice(0, 6).replace(number[1], '')))
          case !number[0].test(value):
            return dispatch(setCreatePin(value.replace(number[1], '')))
          default:
            return dispatch(setCreatePin(value))
        }
      case 'reset_confirm_pin':
        switch (true) {
          case value?.length > 6:
            return dispatch(setConfirmPin(value.slice(0, 6).replace(number[1], '')))
          case !number[0].test(value):
            return dispatch(setConfirmPin(value.replace(number[1], '')))
          default:
            return dispatch(setConfirmPin(value))
        }
      default:
        break
    }
  }

  return {
    setValidFunc,
  }
}
